import TitleImage from "./title-image";

export default TitleImage;